import { render, staticRenderFns } from "./DocumentsLinkList.vue?vue&type=template&id=2eece63c"
import script from "./DocumentsLinkList.vue?vue&type=script&lang=js"
export * from "./DocumentsLinkList.vue?vue&type=script&lang=js"
import style0 from "./DocumentsLinkList.vue?vue&type=style&index=0&id=2eece63c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports